import type { PatchSession } from '../../../services/api/patchSession.api'

export type PatchSessionView = 'pending' | 'connected' | 'terminal'

/**
 * Which treatment a session gets, derived from the session itself.
 *
 * This is a read, not a setting. There is no `ChatMode` and no
 * `resolveComposerTarget` any more: the service has one message endpoint, so
 * the composer has nothing to choose between. What a turn can do is decided by
 * the backend from the chat's subject and the caller's `api:patcher` grant, and
 * starting a session is an approval-gated tool the agent proposes.
 *
 * Total over a real session, deliberately: there is no `'setup'` member and the
 * parameter is not nullable. Choosing between "a session exists" and "offer the
 * start form" belongs to the parent, which has to null-check anyway to decide
 * whether to mount the banner at all — handing it a `'setup'` verdict would
 * just be that same null test computed twice.
 */
export function resolvePatchSessionView(session: PatchSession): PatchSessionView {
  if (session.status === 'connected') return 'connected'
  if (session.status === 'pending_authorization') return 'pending'
  return 'terminal'
}
